import * as React from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import { IIconProps } from '../Helpers/Common';

export enum Display {
	Solid = 'btn--solid',
	Outline = 'btn--outline',
	Text = 'btn--text',
	None = '',
	OutlineDashed = 'btn--outline-dashed',
}

export enum Colors {
	Primary = 'btn--primary',
	Secondary = 'btn--secondary',
	Warning = 'btn--warning',
	Error = 'btn--error',
	Success = 'btn--success',
	None = '',
	Alternate = 'btn--alternate',
}

export enum Sizes {
	ExtraSmall = 'btn--xsm',
	Small = 'btn--sm',
	Medium = 'btn--md',
	Large = 'btn--lg',
	ExtraLarge = 'btn--xlg',
	None = '',
}

export enum Widths {
	auto = 'btn--auto-width',
	fullWidth = 'btn--full-width',
	small = 'btn--width-sm',
	medium = 'btn--width-md',
	large = 'btn--width-lg',
}

export interface ICbButtonProps {
	type?: 'submit' | 'reset' | 'button';
	display?: Display;
	colors?: Colors;
	sizes?: Sizes;
	widths?: Widths;
	buttonProps?: React.ButtonHTMLAttributes<Element>;
	children: React.ReactNode;
	className?: string;
	disabled?: boolean;
	onClick?: ((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void);
	icon?: IIconProps;
	labelVisible?: false;
}

@observer
export class Button extends React.Component<ICbButtonProps> {
	static defaultProps: Partial<ICbButtonProps> = {
		colors: Colors.Primary,
	}

	public render() {
		const {
			labelVisible: labelVisibleProp,
			type,
			widths: widthsProp,
			sizes: sizesProp,
			children,
			onClick: onClickProp,
			icon: iconProp,
			display: displayProp,
			colors: colorsProp,
			className: classNameProp,
			buttonProps,
		} = this.props;
		const icon = iconProp ? `btn--icon icon-${iconProp.icon} ${iconProp.iconPos}` : '';
		const display = displayProp ?? '';
		const colors = colorsProp ?? '';
		const sizes = sizesProp ?? '';
		const widths = widthsProp ?? '';
		const className = classNameProp ?? '';
		const { disabled } = this.props;

		const clazz = ['btn', icon, display, colors, sizes, widths, className];

		const onClick = onClickProp ?? buttonProps?.onClick;

		const labelVisible = (labelVisibleProp === undefined) ? true : labelVisibleProp;
		const label = typeof children === 'string' ? children : undefined;

		return (
			<button
				type={type ?? 'button'}
				onClick={onClick}
				className={classNames(clazz)}
				aria-label={!labelVisible ? label : undefined}
				disabled={disabled}
				{...buttonProps}
			>
				{labelVisible ? children : null}
			</button>
		);
	}
}
